import {setServiceName} from '../components/setters';
import {history, tax} from '../globals/config';
import switchStep from '../components/switchStep';
import {formatDuration} from '../../appointment-tool/modules/serviceSelector';
import {menaPrice} from '../../components/tools';
import qtAnalytics from '../components/qtAnalytics';

const $ = jQuery;
const $modal = $('.js-qt-diagnosis-service-modal');
const $quoteToolContainer = $('#quote-tool');

export let serviceDescriptionData = [];
export default function () {
    modal();

    $quoteToolContainer.on('click', '.js-qt-confirm-diagnosis', function () {
        setServiceName();
        getModuleData();
        setServiceDescriptionData();

        qtAnalytics('result-submit');
        switchStep('vehicle', serviceDescriptionData.apiServiceId);
        history.push('vehicle');

        $('.js-qt-return').show();
    });

    $quoteToolContainer.on('click', '.js-qt-diagnosis-service-link', function () {
        window.open($(this).attr('data-service-url'), '_blank');
    });
}

/**
 * Get service description data
 */
function getModuleData() {
	let $moduleContainers = $('.c-qt-diagnosis__service');
	let servicesData = [];
    // Clear existing services
    serviceDescriptionData = [];

	$moduleContainers.each(function () {
		let $this = $(this);
		let price = $this.attr('data-service-price');
		price = price && parseFloat(price) > 0 ? parseFloat(price) * tax : 0;
		price = price.toFixed(2);

		let serviceData = {
			apiServiceId: $this.attr('data-service-id'),
			price: parseFloat(price),
			duration: $this.attr('data-service-duration'),
			name: $this.find('.js-qt-diagnosis-service-name').text(),
		};

		servicesData.push(serviceData);

        // Store it in global variable
        serviceDescriptionData.push(serviceData);

	});
}

function setServiceDescriptionData() {
    let $nextStepModule = $('.c-qt-vehicle-select, .c-qt-schedule');
    let $services = $nextStepModule.find('.js-tool-sidebar--items.services');


    // Clear existing services before appending new ones
    $services.empty();

    // Calculate total price
    let totalPrice = serviceDescriptionData.reduce((acc, service) => acc + parseFloat(service.price), 0);

    serviceDescriptionData.forEach(service => {
        $services.append(
            $('<li>').addClass('tool-sidebar__flex').append(
                $('<span>').addClass('font-medium').text(service.name),
                $('<span>').addClass('price').text(menaPrice(service.price, false)),
            )
        );
    });
    // Calculate total duration in hours from all services
    let totalDurationHours = serviceDescriptionData.reduce((acc, service) => acc + parseFloat(service.duration), 0);
    // Use the existing formatDuration function to format the total duration
    let formattedTotalDuration = formatDuration(totalDurationHours);
    // Display the formatted total duration
    $nextStepModule.find('.js-tool-sidebar--duration').text(formattedTotalDuration);

    // Update total price
    $nextStepModule.find('.js-tool-sidebar--total').text(menaPrice(totalPrice));
}

/**
 * Modal functionality
 */
export function modal() {
    $('.js-qt-diagnosis-service-cta').on('click', function (e) {
		// Find parent .c-qt-diagnosis__service-name and it's next element sibling is modal
        let $modal = $(this).closest('.c-qt-diagnosis__service-name').next();
		e.preventDefault();
		toggleModal(false,$modal);
	});

    $(document).on('click', function (e) {
        let $modal = $('.js-qt-diagnosis-service-modal.active');
        let $target = $(e.target);

        if (!$target.hasClass('js-qt-diagnosis-service-modal') && !$target.closest($modal).length > 0 && !$target.hasClass('js-qt-diagnosis-service-cta')) {
            toggleModal(true, $modal);
        }
    });

    $(document).on('click', '.js-ap-diagnosis-service-modal-close', function () {
        let $modal = $('.js-qt-diagnosis-service-modal.active');
        toggleModal(true, $modal);
    });
}

/**
 * Create modal content
 * @param items
 */
export function createServiceItems(items) {
    const $listContainer = $('.js-qt-diagnosis-service-modal-items');
    $listContainer.empty();

    if (items) {
        let $list = $('<ul></ul>');
        items.forEach((item) => {
            $list.append(`<li>${item.item}</li>`);
        });

        $listContainer.append($list);
    }
}

/**
 * Toggle modal
 * @param removeModal
 */
export function toggleModal(removeModal = false, $modal) {
    if (removeModal) {
        $modal.slideUp(300).removeClass('active');
        $('.modal-overlay').removeClass('active');
        return;
    }
    $('.modal-overlay').addClass('active');
    $modal.slideToggle(300).toggleClass('active');
}
